import { CURRENCY } from "utils/constants";

const Money = ({ value = 0, currency = CURRENCY, minimumFractionDigits = 2 }) => new Intl.NumberFormat("de-DE", {
	style: "currency",
	currency,
	maximumFractionDigits: 2,
	minimumFractionDigits,
})
	.format(value)
	.replace(/\s/g, "");
	
export default Money;
